<template>
  <div class="user-center">
    <div class="user-center-info">
      <!-- <div class="info"> -->
      <van-image :src="avatarImg" width="76px" height="76px" fit="fit" round />

      <div class="info-name">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="name">{{ user.name }}</div>
          <!-- <div class="nickName" @click="$router.push('/editNickNm')">
            昵称：{{ user.nickName }}&nbsp;<van-icon name="edit" />
          </div> -->
        </div>
        <div class="company">{{ user.dealerName }}</div>
        <div class="company">{{ user.postNameEn }}</div>
      </div>
      <!-- </div> -->
    </div>
    <div style="padding:0 20px">
      <!-- <div class="user-center-badge">
        <div class="badge">
          <van-image v-for="(e, key) in badgeList" :key="key" :src="e" width="15" height="13" />
        </div>

        <div class="num">
          徽章数：<span>{{ badgeList.length }}</span>
        </div>
      </div> -->
      <div class="user-center-detail">
        <div>
          <div class="num">{{ user.studyCourseNum || 0 }}</div>
          <div>已学课程</div>
        </div>
        <div>
          <div class="level">{{ user.passportName || '-' }}</div>
          <div>护照等级</div>
        </div>
        <div>
          <div class="num">{{ user.integral.toLocaleString('en-US') || 0 }}</div>
          <div>当年学分</div>
        </div>
      </div>
      <div class="user-center-list">
        <van-cell title="我的消息" is-link @click="$router.push('/notice')">
          <template #default>
            <div class="notice-num" v-if="newNotices != 0">{{ newNotices }}</div>
          </template>
        </van-cell>
        <van-cell title="我的排行榜" is-link @click="showRankPop" />
        <van-cell title="历年学分" is-link @click="$router.push('/historyList')" />
        <van-cell title="充电保学分" is-link @click="$router.push('/cdbList')" />

        <!-- <van-cell title="修改密码" is-link @click="$router.push('/editPwd')" /> -->
        <van-cell title="意见反馈" is-link @click="$router.push('/feedback')" />
        <van-cell title="退出" is-link @click="logout" />
      </div>
    </div>
    <van-popup v-model="showPickder" class="user-center-pop" position="bottom">
      <!-- <div class="pop-btn" @click="getVideo">拍照</div> -->
      <div class="pop-btn">
        <van-uploader :after-read="afterRead">
          拍照或从相册中选择
        </van-uploader>
      </div>
      <div class="pop-btn cancel" @click="showPickder = false">取消</div>
    </van-popup>

    <van-popup v-model="rankPop" class="user-center-rank" position="bottom" closeable>
      <div class="rank-pop-box">
        <div>PC内排名：</div>
        <div class="num">
          <van-image :src="require('../../assets/img/rank-left.png')" fit="contain" height="44px" />
          <span>{{ pcRank }}</span>
          <van-image
            :src="require('../../assets/img/rank-right.png')"
            fit="contain"
            height="44px"
          />
        </div>
      </div>
      <div class="rank-pop-box">
        <div>集团内排名：</div>
        <div class="num">
          <van-image :src="require('../../assets/img/rank-left.png')" fit="contain" height="44px" />
          <span>{{ jtRank }}</span>
          <van-image
            :src="require('../../assets/img/rank-right.png')"
            fit="contain"
            height="44px"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import '@/assets/_variable.scss'
import { getUserByPpn, getUserSort, updateAvatar } from '@/api/user/index.js'
import { getNoticeNewNum, uploadFile } from '@/api/common/index.js'
import { logoutPPN } from '@/api/index.js'

import { Toast } from 'vant'
export default {
  name: 'UserCenter',
  data() {
    return {
      //fileList: [],
      //userType: localStorage.getItem('userType'),
      //avatarImg: require('../../assets/img/banner-2.png'),
      badgeList: [],
      PPN: '',
      user: {
        userMapList: [],
        integral: 0,
        integralTotal: 0,
      },
      newNotices: 0,
      rankPop: false,
      showPickder: false,
      pcRank: '-',
      jtRank: '-',
    }
  },
  created() {},
  methods: {
    afterRead(file) {
      console.log(file.file)
      const formData = new FormData()
      formData.append('file', file.file)
      uploadFile(formData).then((res) => {
        console.log(res)
        updateAvatar({
          avatar: res.url,
        }).then(() => {
          Toast.success('修改成功！')
          this.showPickder = false
          this.getUser()
        })
      })
    },
    showRankPop() {
      this.getSort()
      this.rankPop = true
    },
    getSort() {
      getUserSort({
        ppn: this.PPN,
      }).then((res) => {
        this.pcRank = res.data.pcSort
        this.jtRank = res.data.jtSort
      })
    },
    getUser() {
      getUserByPpn({
        ppn: this.PPN,
      }).then((res) => {
        this.user = res.data
        if (res.data.passportAvatar != '') {
          this.avatarImg = res.data.passportAvatar
        }
        res.data.userMapList.forEach((item) => {
          if (item.mapStudy == '1') {
            this.badgeList.push(item.img)
          }
        })
      })
    },
    getVideo() {},
    changeAvatar() {
      this.showPickder = true
    },
    logout() {
      // this.$router.push('/login')
      logoutPPN().then((res) => {
        localStorage.clear()
        this.setWechat()
      })
    },
    setWechat() {
      let jumpUrl = 'https://porsche-lp.rps-china.com.cn'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx827aa5cff11c458c&redirect_uri=${jumpUrl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    },
    getNews() {
      getNoticeNewNum({}).then((res) => {
        this.newNotices = res.data
      })
    },
  },
  mounted() {
    this.PPN = JSON.parse(localStorage.getItem('user')).ppn
    this.getUser()
    this.getNews()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.user-center {
  width: 100%;
  padding: 20px 0;
  height: 100%;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;
  &-logo {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  &-info {
    display: flex;
    // justify-content: space-between;
    // height: 80px;
    align-items: start;
    padding: 0 20px;
    margin-bottom: 6px;
    .van-image {
      //border: 2px solid #fff;
    }
    .info-name {
      flex: 1;
      padding: 8px 0 8px 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-size: 22px;
        color: #000;
      }
      .nickName {
        font-size: 12px;
        color: #000;
      }
      .company {
        font-size: 12px;
        color: #403f45;
      }
    }
    // .info {
    //   display: flex;
    //   align-items: center;
    // }
    .job {
      position: relative;
      min-width: 95px;
      max-width: 130px;
      min-height: 30px;
      line-height: 30px;
      text-align: right;
      padding: 0 5px 0 10px;
      background: url('../../assets/img/job-bg.png') top left no-repeat,
        linear-gradient(90deg, transparent 20px, #d5001c);
      background-size: cover;
      color: #fff;
      font-size: 12px;
      overflow: hidden;
    }
  }
  &-badge {
    display: flex;
    padding: 5px 15px;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
    .badge {
      display: flex;
      width: 110px;
      .van-image {
        margin-right: 3px;
      }
    }
    .num {
      font-size: 12px;
      span {
        color: #d5001c;
      }
    }
  }
  &-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 58px;
    border-radius: 6px;
    background: linear-gradient(180deg, #737278 0%, #403f45 100%);
    margin-bottom: 10px;
    & > div {
      padding: 0 20px;
      font-size: 11px;
      text-align: center;
      color: #fff;
      .num {
        font-family: 'Porsche Next Bold';
        font-size: 18px;
        font-weight: 700;
      }
      .level {
        color: #d5001c;
        font-family: 'Porsche Next Bold';
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
  &-list {
    .van-cell {
      align-items: center;
      border-radius: 6px;
      margin-bottom: 10px;
      font-size: 15px;
    }
    .notice-num {
      font-family: 'Porsche Next';
      float: right;
      width: 32px;
      height: 18px;
      line-height: 20px;
      border-radius: 32px;
      background-color: #d5001c;
      color: #fff;
      text-align: center;
      font-size: 12px;
    }
  }
  &-pop {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: transparent;
    .pop-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90%;
      height: 48px;
      background-color: #fff;
      border-radius: 6px;
      margin-bottom: 10px;
      color: #d5001c;
      font-size: 16px;
      &.cancel {
        margin-top: 20px;
      }
    }
  }
  &-rank {
    .rank-pop-box {
      margin: 20px 20px 10px;
      & > div {
        margin-bottom: 10px;
        font-size: 15px;
      }
      .num {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        color: #000;
        font-family: 'Porsche Next';
        font-size: 24px;
        font-weight: 700;
        & > span {
          width: 80px;
          text-align: center;
        }
      }
    }
  }
}
</style>
